import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { assets } from 'assets/assets';
import Container from 'components/Container';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Typed from 'react-typed';

const images = assets.indexView.templateScreens;

const Hero = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(to bottom, ${alpha(
          theme.palette.background.paper,
          0,
        )}, ${alpha(theme.palette.alternate.main, 1)} 100%)`,
        backgroundRepeat: 'repeat-x',
        position: 'relative',
      }}
    >
      <Box paddingY={{ xs: '0', sm: '4rem', md: '4rem' }}>
        <Container>
          <Box maxWidth={{ xs: 1, sm: '50%' }}>
            <Box marginBottom={2}>
              <Chip
                label="Software Engineering & AI Delivery from Lagos, Nigeria"
                color="primary"
                variant="outlined"
                sx={{ fontWeight: 600, fontSize: '0.85rem' }}
              />
            </Box>
            <Typography
              variant="h2"
              component={'h1'}
              color="text.primary"
              gutterBottom
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2.25rem', sm: '3rem', md: '3.5rem' },
                lineHeight: 1.15,
              }}
            >
              Build better software.{' '}
              <Typography
                color={'primary'}
                component={'span'}
                variant={'inherit'}
                sx={{
                  background: `linear-gradient(180deg, transparent 82%, ${alpha(
                    theme.palette.secondary.main,
                    0.3,
                  )} 0%)`,
                }}
              >
                <Box height={1} component={'span'} marginLeft={1}>
                  <Typed
                    strings={[
                      'Expand Now.',
                      'Scale with AI.',
                      'Deliver faster.',
                    ]}
                    typeSpeed={70}
                    loop={true}
                  />
                </Box>
              </Typography>
            </Typography>
            <Typography
              variant="h6"
              component="p"
              color="text.secondary"
              sx={{ fontWeight: 400, marginTop: 2, lineHeight: 1.6 }}
            >
              Topibro Technologies helps startups and global companies design,
              build, operate, and scale web, mobile, cloud, and AI-powered
              products. Work with us on a complete project, extend your
              engineering team, or bring technology into African markets with a
              local delivery partner.
            </Typography>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretch', sm: 'center' }}
              gap={2}
              marginTop={4}
            >
              <Button
                component={'a'}
                variant="contained"
                color="primary"
                size="large"
                fullWidth={!isMd}
                href={'/contact-us'}
                sx={{ fontWeight: 700, paddingX: 4, paddingY: 1.5 }}
              >
                Start a Project
              </Button>
              <Button
                component={'a'}
                variant="outlined"
                color="primary"
                size="large"
                fullWidth={!isMd}
                href={'/web-development'}
                sx={{ fontWeight: 600, paddingX: 3, paddingY: 1.5 }}
              >
                Explore Capabilities
              </Button>
            </Box>
            <Stack
              direction="row"
              spacing={1}
              useFlexGap
              flexWrap="wrap"
              marginTop={4}
              sx={{ opacity: 0.85 }}
            >
              {[
                'Web Applications',
                'Mobile',
                'Backend & Cloud',
                'AI Solutions',
                'Product Engineering',
                'Africa Delivery',
              ].map((item, idx) => (
                <Chip
                  key={idx}
                  label={item}
                  size="small"
                  variant="filled"
                  sx={{ fontSize: '0.75rem', fontWeight: 500 }}
                />
              ))}
            </Stack>
          </Box>
        </Container>
        <Box
          sx={{
            transform: 'rotate(-20deg)',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          <Box
            display={'flex'}
            width={'50rem'}
            left={'50%'}
            top={0}
            position={'absolute'}
            sx={{ transform: 'translate3d(20%, -50%, 0)' }}
          >
            {images.map((item, i) => (
              <Box key={i} marginTop={{ sm: -(i * 5) }} marginX={1}>
                {item.group.map((g, j) => (
                  <Box
                    key={j}
                    padding={1}
                    bgcolor={'background.paper'}
                    borderRadius={2}
                    boxShadow={3}
                    marginTop={2}
                  >
                    <Box
                      component={LazyLoadImage}
                      effect="opacity"
                      src={g.cover}
                      alt="Topibro Technologies product engineering showcase"
                      height={1}
                      width={1}
                      maxWidth={320}
                    />
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      <Box
        component={'svg'}
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1920 100.1"
        sx={{
          width: '100%',
          marginBottom: theme.spacing(-1),
        }}
      >
        <path
          fill={theme.palette.background.paper}
          d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
        ></path>
      </Box>
    </Box>
  );
};

export default Hero;
